import React from 'react';
import { CalendarAddLined } from '@tag/tag-icons';

import SectionCard from '@/components/common/SectionCard/SectionCard';
import styles from './download-template.module.scss';
import { getBillingIntervals } from '@/utils/data-helpers/intervals';
import { Checkbox, CheckboxChange } from '@/components/common/CheckboxTag4/CheckboxTag4';

const MULTI_YEAR = 'Multi Year';

const customTitleStyle = {
  fontSize: '16px',
  fontWeight: 500,
  marginLeft: '-15px',
  display: 'flex',
  alignItems: 'center'
};

interface IDownloadBillingInterval {
  billingIntervalsSelected: string[];
  onBillingIntervalChange: (event: CheckboxChange) => void
}

function DownloadBillingInterval({ billingIntervalsSelected, onBillingIntervalChange }: IDownloadBillingInterval) {
  const billingIntervals = getBillingIntervals().reduce((intervals, interval) =>
    [...intervals, interval.formattedBillingInterval], [MULTI_YEAR]);
  return (
    <SectionCard
      title={{ titleText: 'Billing Interval', titleIcon: CalendarAddLined }}
      customTitleStyle={customTitleStyle}
      collapsable={{ buttonText: 'billing options', secondaryIcon: true, defaultOpen: false }}
      padding={true}
    >
      <div className={styles.checkBoxes}>
        {billingIntervals.map(intervalName => (
          <Checkbox key={intervalName}
            name={intervalName}
            checked={billingIntervalsSelected.includes(intervalName)}
            onChange={onBillingIntervalChange}
          >
            {intervalName}
          </Checkbox>
        ))}
      </div>
    </SectionCard>
  );
}

export default DownloadBillingInterval;
